<template>
  <div
    id="not-found"
    :class="themeSelected"
    :style="
      `padding-right: ${sidebarPosPadding}px; max-width: ${wrapperWidth}px`
    "
  >
    <div>
      <img :src="siteLogo" :alt="websiteName" />
      <h1 class="mt-3 mb-4">Page not found</h1>
      <router-link to="/" class="styled-btn">Home page</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState([
      'siteLogo',
      'websiteName',
      'sidebarPosPadding',
      'wrapperWidth',
      'themeSelected'
    ]),
  },
  metaInfo() {
    const dataSiteName = this.websiteName;
    return {
      title: 'Page not found',
      titleTemplate: `%s | ${dataSiteName}`,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';

#not-found {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  text-align: center;
  transition: all 0.3s ease;

  &.dark {
    background: $color1;
  }

  &.light {
    background: $color9;
  }

  @media (max-width: $size-desktop) {
    padding-right: 0 !important;
  }
}
</style>
